// // // Spinner.js

// import React from 'react';
// import styled, { keyframes } from 'styled-components';

// const spinAnimation = keyframes`
//   0% { transform: rotate(0deg); }
//   100% { transform: rotate(360deg); }
// `;

// const SpinnerOverlay = styled.div`
//   position: fixed;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
//   background-color: rgba(255, 255, 255, 0.5);
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   z-index:1000000;
// `;

// const SpinnerContainer = styled.div`
//   width: 50px;
//   height: 50px;
//   position: relative;
// `;

// const SpinnerCircle = styled.div`
//   width: 50px;
//   height: 50px;
//   border: 3px solid #f3f3f3; /* Light grey border */
//   border-top: 3px solid #3498db; /* Blue border for spinner animation */
//   border-radius: 50%;
//   animation: ${spinAnimation} 1s linear infinite; /* Animation for spinning */
// `;

// const Spinner = () => {
//   return (
//     <SpinnerOverlay>
//       <SpinnerContainer>
//         <SpinnerCircle />
//       </SpinnerContainer>
//     </SpinnerOverlay>
//   );
// }

// export default Spinner;


import React from "react";
import { useSelector } from "react-redux";
import styled, { keyframes } from "styled-components";

const Spinner = () => {
  const isLoading = useSelector((state) => state.ui.isLoading);

  if (!isLoading) return null;

  return (
    <Overlay>
      <Spinnerele />
    </Overlay>
  );
};

export default Spinner;

// Spinner Styles
const spin = keyframes`
  to { transform: rotate(360deg); }
`;

const Overlay = styled.div`
  position: fixed;
  inset: 0;
  background: rgba(255, 255, 255, 0.6);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Spinnerele = styled.div`
  width: 60px;
  height: 60px;
  border: 5px solid #999;
  border-top-color: #3498db;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;
